import React from 'react';
import Card from '../../../../core/layout/Card';
import ContentVisualizationToggle from './ContentVisualizationToggle';
import ContentCourseListScene from './ContentCourseListScene';
import ContentCourseChartScene from './ContentCourseChartScene';

class ContentCourseTab extends React.Component {
  state = {
    visualization: 'chart',
  };

  handleChangeVisualization = (value) => {
    this.setState({
      visualization: value,
    });
  };

  render() {
    return (
      <div>
        <Card
          actions={
            <ContentVisualizationToggle onChange={this.handleChangeVisualization} value={this.state.visualization} />
          }
        >
          {this.state.visualization === 'list' && <ContentCourseListScene />}
          {this.state.visualization === 'chart' && <ContentCourseChartScene />}
        </Card>
      </div>
    );
  }
}

export default ContentCourseTab;
